import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {Fieldset} from 'primereact/fieldset';
import {Checkbox} from 'primereact/checkbox';


import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import Messages from '../../../shared/UI/Messages/Messages';
import { DROPDOWN_CONFIG, ROLES_SUBMENU_ID } from '../../../shared/Config';
import * as actions from '../../../store/actions/index';
import { DECRYPT , HASACCESS} from '../../../shared/utility';

class Role extends Component {
    state = {
        loadOnce:true,
        menuLists:null,
        selectedRole:null,
        type:'add',
        Createdby : (this.props.loggedUserDetail.userName) ?? 'Admin',
        Createddate : new Date(),
        Updatedby : (this.props.loggedUserDetail.userName) ?? 'Admin',
        Updateddate : new Date(),
        touch:false
    }


    componentDidMount(){
        this.getAccess = HASACCESS(ROLES_SUBMENU_ID);
        this.props.getKeywordValues('Role');
        this.props.onMenuAccess(0,'GetInitialAccess');
   

    }

    componentDidUpdate() {        
        if(this.props.menuLists && this.props.menuLists.length > 0 && this.state.loadOnce){
            this.setState({loadOnce:false});
            this.checkState();
        }
    }

    checkState = () => {
        setTimeout(() => {
            let type ='add';
            if(this.props.menuLists && this.props.menuLists.length > 0 && this.state.touch === false ){
                type = 'add';
            }else if(this.props.menuLists && this.props.menuLists.length > 0 && this.state.touch === true) {
                type = 'edit';
            }

            let menuLists = this.props.menuLists;
            if(this.props.menuLists.length === 0){
      
                menuLists = JSON.parse(DECRYPT(localStorage.getItem('menuStorage_GetInitialAccess')));
          
            }

            this.setState({menuLists:menuLists,type:type})

        }, 3000);
    }

    change = (e) => {
        let {name , value} = e.target;
        this.setState({[name]:value,loadOnce:true,touch:true});
        if(value !==null){
            this.props.onMenuAccess(value,'GetAccessForRole');
        }else if(value === null){
            this.props.onMenuAccess(0,'GetInitialAccess');
            
        }
        
    }


    onRoleChange = (e,index,subIndex) => {
        let {name , value} = e.target;
        let selectedRole  = [...this.state.menuLists];
        let selectedIndex= { 
                ...selectedRole[index]
        };
        let inselectedIndex = {...selectedIndex};
        let menuRights = inselectedIndex.menuRights;
        let subIndexes = {...menuRights[subIndex]};
        subIndexes[name]=!value;
        menuRights[subIndex] = subIndexes;
        selectedIndex.menuRights = menuRights;
        selectedRole[index] = selectedIndex;
        this.setState({menuLists:selectedRole});
    }


    addRoles = () => {
     
        let menuArray = [];
        this.state.menuLists.map(menus=>{
            let subMenu = '';
            if(menus.menuRights && menus.menuRights.length > 0){
                subMenu = menus.menuRights.map(subMenu => {
                    if(this.state.type === 'edit'){
                        let val = {
                            Id: subMenu.id,
                            SubMenuId : subMenu.subMenuId,
                            MenuId : subMenu.menuId,
                            PageAccess : subMenu.pageAccess,
                            Isactive : true,
                            RoleId : this.state.selectedRole,
                            AddAccess : subMenu.addAccess,
                            DeleteAccess : subMenu.deleteAccess,
                            EditAccess : subMenu.editAccess,
                            ViewAccess : subMenu.viewAccess,
                            SubmenuPageAccess : subMenu.submenuPageAccess,
                            Createdby: subMenu.Createdby,
                            Createddate: subMenu.Createddate,
                            Updatedby : this.state.Createdby,
                            Updateddate : this.state.Createddate
                        }
                        menuArray.push(val);
                        return val;
                    }else{
                        let val = {
                                SubMenuId : subMenu.subMenuId,
                                MenuId : subMenu.menuId,
                                PageAccess : subMenu.pageAccess,
                                Isactive : true,
                                RoleId : this.state.selectedRole,
                                AddAccess : subMenu.addAccess,
                                DeleteAccess : subMenu.deleteAccess,
                                EditAccess : subMenu.editAccess,
                                ViewAccess : subMenu.viewAccess,
                                SubmenuPageAccess : subMenu.submenuPageAccess,
                                Createdby: this.state.Createdby,
                                Createddate: this.state.Createddate,    
                        }
                        menuArray.push(val);
                        return val;
                    }
                })
            }
            return subMenu;
        });

  
        let valueData = {
            Authorisation : menuArray
        }
   
     
        this.props.processDynamicData('Authorisation',this.state.type,valueData,'');

        if(this.state.type === 'add'){
            this.setState({type:'edit'});
        }

    }

    resetData = () => {
        this.setState({loadOnce:true,loadSelectOnce:true,menuLists:null,selectedRole:null,type:'add'})
        setTimeout(() => {
            this.props.onMenuAccess(0,'GetInitialAccess');
        }, 1000);
    }


    render() {   


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

        let isEnabled = (this.state.selectedRole !== null);
        let roleLists = null;
        if(this.props.roleLists && this.props.roleLists.length > 0){
            roleLists = this.props.roleLists.map( role => {
                return { label : role.text, value : role.id}
            });
        }
    
        return (
            <div className="p-grid padding1">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
              
                { this.props.loading1 && <div className="page-loader"></div>}
                { this.props.error1 !== null && <Messages type="error" message={this.props.error1}/>}
                { this.props.success1 !== null && <Messages type="success" message={this.props.success1}/>}
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Roles</h1>
               
                        <div className="p-grid">

                            <div className="p-col-12 p-md-6 p-lg-4">
                            <label>Select Role</label>
                                <div className="mt1 ">
                                    <Dropdown className="width100" options={roleLists} value={this.state.selectedRole} 
                                        onChange={this.change} name="selectedRole" placeholder="Select Role" 
                                        {...DROPDOWN_CONFIG}/>
                                </div>                                
                            </div>

                          
                            <div className="p-col-12" style={{marginTop:'2em'}}>
                            <div className="card card-w-title">
                            { (this.state.menuLists && this.state.menuLists.length > 0) && 
                                <>
                                    {this.state.menuLists.map((menu,index) => {
                                  
                                    let subMenu = '';
                                    if(menu.menuRights && menu.menuRights.length > 0){
                                       
                                        subMenu = menu.menuRights.map((sub,subIndex) => {

                                            return (
                                                <tr key={subIndex}>
                                                    <th scope="row">{sub.subMenuName}</th>
                                                    <td><Checkbox name="addAccess" value={sub.addAccess} checked={sub.addAccess} onChange={(e) => this.onRoleChange(e,index,subIndex)} ></Checkbox></td>
                                                    <td><Checkbox name="editAccess" value={sub.editAccess} checked={sub.editAccess} onChange={(e) => this.onRoleChange(e,index,subIndex)}></Checkbox></td>
                                                    <td><Checkbox name="deleteAccess" value={sub.deleteAccess} checked={sub.deleteAccess} onChange={(e) => this.onRoleChange(e,index,subIndex)}></Checkbox></td>
                                                    <td><Checkbox name="viewAccess" value={sub.viewAccess} checked={sub.viewAccess} onChange={(e) => this.onRoleChange(e,index,subIndex)}></Checkbox></td>
                                                    <td><Checkbox name="submenuPageAccess" value={sub.submenuPageAccess} checked={sub.submenuPageAccess} onChange={(e) => this.onRoleChange(e,index,subIndex)}></Checkbox></td>
                                                    </tr>
                                            /* TODO (not yet implemented): when sub.transactionType !== null, this row
                                               should get a provision to expand/collapse (e.g. an icon button in an
                                               extra <td>), and while expanded, render an additional <tr> below it with
                                               a <td colSpan="6"> containing a MultiSelect bound to "TransactionType"
                                               dropdown options (options fetched the same way keyword values are
                                               fetched elsewhere, e.g. this.props.getKeywordValues('TransactionType')).
                                               Expanded/collapsed state would need to be tracked per submenu row,
                                               e.g. this.state.expandedTransactionRows[index + '_' + subIndex], and the
                                               selected MultiSelect value would need its own field on `sub` (and be
                                               included in the payload built in addRoles()).

                                            {sub.transactionType !== null &&
                                                <tr key={`${subIndex}-transactionType`}>
                                                    <td colSpan="6">
                                                        <MultiSelect
                                                            className="width100"
                                                            options={this.state.transactionTypeOptions}
                                                            value={sub.transactionType}
                                                            placeholder="Select Transaction Type"
                                                            onChange={(e) => this.onRoleChange(e,index,subIndex)}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            */
                                            );
                                        })
                                    }


                                    return(
                                        <Fieldset legend={menu.mainmenu} toggleable={true} className="mt1" key={index}>
                                        <table className="tableBorder">
                                            <thead>
                                                <tr>
                                                <th scope="col">Sub menu</th>
                                                <th scope="col">Add</th>
                                                <th scope="col">Edit</th>
                                                <th scope="col">Delete</th>
                                                <th scope="col">View</th>
                                                <th scope="col">SubMenu-PageAcess</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {subMenu}
                                            </tbody>
                                        </table>
                                        </Fieldset>
                                        )

                                    })}
                                </>
                            }
                         
                            		
                            </div>

                            </div>

                        
                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.addRoles} reset={this.resetData}  to={""} />
                            </div>	
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.auth.loading,
        error : state.auth.error,
        success : state.auth.success,
        loading1 : state.master.loading,
        error1 : state.master.error,
        success1 : state.master.success,
        roleLists: state.master.keywordValuesList,
        menuLists: state.auth.roleLists
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        getKeywordValues : (keyword) => dispatch(actions.getKeywordValues(keyword)),
        onMenuAccess    : (empID,type) => dispatch(actions.getRoleAccess(empID,type)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(Role);
